import { useNavigate } from "react-router-dom";
import { useContext  } from "react";
import {
  Box,
  Button,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import "./styles.css";
import { makeStyles } from "@mui/styles";
import AuthContext from "../../context/AuthContext";

const useStyles = makeStyles({
  editButton: {
    visibility: "hidden",
  },
  campaignButton: {
    "&:hover $editButton": {
      visibility: "inherit",
    },
  },
});

export default function AccountServicesList({
	selectedService,
  revenueTargetingModels,
  selectedRevenueTargetingModelID,
  loading,
  getModels,
}) {

  const auth = useContext(AuthContext);

  const classes = useStyles();

  const navigate = useNavigate();

  const handleClick = (service) => {
    navigate(`/account/${auth.userAccount.id}/${service}`);
  };

	console.log(auth)

  return (
    <>
      <Box
        sx={{ backgroundColor: "neutral.main", padding: "12px 24px 12px 24px" }}
      >
        <Button
          onClick={() => {navigate(`/`);}}
          variant="contained"
          color="primary"
          sx={{ width: "100%", fontWeight: "bold" }}
        >
          Back To Models
        </Button>
      </Box>
      {loading ? (
        <Box
          sx={{
            backgroundColor: "#fdfdfd",
            width: "100%",
            textAlign: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Paper
          style={{ maxHeight: "calc(100vh - 360px)", overflow: "auto" }}
          elevation={0}
        >
          <List sx={{ backgroundColor: "neutral.main", padding: 0 }}>
            {(auth.userAccountRole === "OWNER" || auth.superUser) ? (
              <ListItem
                button
                className={classes.campaignButton}
                onClick={() => handleClick('billing')}
                variant={
                  selectedService === "billing"
                    ? "campaign-list-selected"
                    : "campaign-list-item"
                }
              >
                <ListItemText
                  primaryTypographyProps={{
                    noWrap: true,
                    variant: "campaign-list-item",
                    style: {
                      paddingRight: "24px",
                    },
                  }}
                  primary={"Billing"}
                />
              </ListItem>
            ) : (
              <ListItem
                button
                className={classes.campaignButton}
                variant={"campaign-list-inactive"}
                secondaryAction={<LockIcon />}
              >
                <ListItemText
                  primaryTypographyProps={{
                    noWrap: true,
                    variant: "campaign-list-item",
                    style: {
                      paddingRight: "24px",
                    },
                  }}
                  primary={"Billing"}
                />
              </ListItem>
            )}
            <ListItem
              button
              className={classes.campaignButton}
              onClick={() => handleClick('users')}
              variant={
                selectedService === "users"
                  ? "campaign-list-selected"
                  : "campaign-list-item"
              }
            >
              <ListItemText
                primaryTypographyProps={{
                  noWrap: true,
                  variant: "campaign-list-item",
                  style: {
                    paddingRight: "24px",
                  },
                }}
                primary={"Users"}
              />
            </ListItem>
            <ListItem
              button
              className={classes.campaignButton}
              onClick={() => handleClick('integrations')}
              variant={
                selectedService === "integrations"
                  ? "campaign-list-selected"
                  : "campaign-list-item"
              }
            >
              <ListItemText
                primaryTypographyProps={{
                  noWrap: true,
                  variant: "campaign-list-item",
                  style: {
                    paddingRight: "24px",
                  },
                }}
                primary={"Integrations"}
              />
            </ListItem>
          </List>
        </Paper>
      )}
    </>
  );
}
